module.exports = __webpack_public_path__ + "static/media/team-introduction-5.7caa0d58.jpg";